import _extends from "@babel/runtime/helpers/extends";
import Divider from "@material-ui/core/esm/Divider";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValueLoadable, useResetRecoilState, useSetRecoilState } from 'recoil';
import getLatestLocalAgreementsForCustomer, { localAgreementCustomerId, localAgreementPagination, localAgreementRequestId } from 'api/localAgreements/getLatestLocalAgreementsForCustomer';
import { getActiveObesForCustomer, getObesForCustomerRequestIdState, obesPagination } from 'api/obes/getObesForCustomer';
import Pagination from 'components/Pagination/Pagination';
import Spinner from 'components/Spinner/Spinner';
import { Title } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import checkLoadable from 'utils/recoil/checkLoadable';
import LocalAgreementItem from './LocalAgreementItem';
export default function LocalAgreements() {
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  const [pagination, setPagination] = useRecoilState(localAgreementPagination);
  const resetPagination = useResetRecoilState(localAgreementPagination);
  const localAgreementsLoadable = useRecoilValueLoadable(getLatestLocalAgreementsForCustomer);
  const {
    contents: localAgreements,
    loading
  } = checkLoadable(localAgreementsLoadable);
  const setCustomerId = useSetRecoilState(localAgreementCustomerId);
  const [requestId, setRequestId] = useRecoilState(localAgreementRequestId);
  const setActiveObeRequestState = useSetRecoilState(getObesForCustomerRequestIdState);
  const resetActiveObePagination = useResetRecoilState(obesPagination);
  const activeObesLoadable = useRecoilValueLoadable(getActiveObesForCustomer(customer?.id));
  const {
    contents: activeObes
  } = checkLoadable(activeObesLoadable);
  useEffect(() => {
    resetPagination();
    resetActiveObePagination();
    setCustomerId(customer?.id);
    setRequestId(id => id + 1);
    setActiveObeRequestState(id => id + 1);
  }, [customer, setCustomerId, setRequestId, resetPagination, setActiveObeRequestState, resetActiveObePagination]);
  const localAgreementsList = localAgreements?.totalResults === 0 ? /*#__PURE__*/React.createElement(Title, {
    align: "center"
  }, t('local_agreement.no_local_agreement')) : localAgreements?.latestExternalSubscriptions?.map((e, i) => /*#__PURE__*/React.createElement("div", {
    key: `${customer?.id}-${pagination.max}-${pagination.offset}-${requestId}-${i}`
  }, /*#__PURE__*/React.createElement(LocalAgreementItem, _extends({}, e, {
    isActive: activeObes?.some(v => e.transactionObeNumber && e.transactionObeNumber === v.obeNumber)
  })), /*#__PURE__*/React.createElement(Divider, null)));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, null, t('local_agreement.local_agreement')), /*#__PURE__*/React.createElement(Divider, null), loading ? /*#__PURE__*/React.createElement(Spinner, null) : localAgreementsList, /*#__PURE__*/React.createElement(Pagination, {
    totalResults: localAgreements?.totalResults ?? 0,
    handlePagination: setPagination,
    paginationParams: pagination,
    rowsPerPageOptions: [5, 10, 30, 100]
  }));
}